import { Platform } from 'react-native';
import { PatternName } from '@/constants/patterns';

export const communities = {
    grommr: {
        code: "grommr",
        name: "Grommr",
        webDescription: "Grommr",
        domain: "grommr.com",
        premiumPlan: "Grommr XL",
        logo: require('@/assets/logos/grommr.png'),
        heroBanner: require('@/assets/banners/hero/grommr.png'),
        tileBanner: require('@/assets/banners/tile/grommr.png'),
        icon: require('@/assets/icons/grommr.png'),
        appIcon: require('@/assets/icons/app-icons/grommr.png'),
        defaultPattern: 'food' as PatternName,
        // Platform-specific IAP product IDs
        inAppProductIdsIos: ["GROM01A", "GROM12A"],
        inAppProductIdsAndroid: ["grom01a", "grom12a"],
        adUnits: {
            ios: "ca-app-pub-4261273451842236/8079522920",
            android: "ca-app-pub-4261273451842236/9945964902"
        },
        isRelationshipMulti: false,
        hasAdvancedWeightFeatures: true,
        klipy: {
            apiKeys: {
                web: '5JzJ8VMbAc81PiR8ZxUgiDYfrhLAR6hZEbafg1JGMtbBLb1UYrbPmO8ibobbBEW2',
                ios: 'Uz7WC8Ln7pYULF8HcQBVxnaUWqoePmfj4KewMgqp879kUlgHoGUBPuPW4NpX6kvT',
                android: 'TjuBSv41x7r5NLfsLpvWUsTXehf7hlRzm3Ab2GhfliRB0lfHkrtbqZocuJeo2vkZ',
            },
        },
    },
    feabie: {
        code: "feabie",
        name: "Feabie",
        webDescription: "Feabie",
        domain: "feabie.com",
        premiumPlan: "Feabie XL",
        logo: require('@/assets/logos/feabie.png'),
        heroBanner: require('@/assets/banners/hero/feabie.png'),
        tileBanner: require('@/assets/banners/tile/feabie.png'),
        icon: require('@/assets/icons/feabie.png'),
        appIcon: require('@/assets/icons/app-icons/feabie.png'),
        defaultPattern: 'food' as PatternName,
        // Platform-specific IAP product IDs
        inAppProductIdsIos: ["FEAB01A", "FEAB12A"],
        inAppProductIdsAndroid: ["feab01a", "feab12a"],
        adUnits: {
            ios: "ca-app-pub-4261273451842236/6766441250",
            android: "ca-app-pub-4261273451842236/3380556558"
        },
        isRelationshipMulti: false,
        hasAdvancedWeightFeatures: true,
        klipy: {
            apiKeys: {
                web: '41QHAmNrqsFZIpU8Hnwj5cj4HyvptgF77W4vAAeoZwtbYrlIcEVBowueqpsIOQT7',
                ios: 'ucpOZm1desNNESBA4OCxJsfwNCmqBtI0lMLf7Y5MqKLoBj9KYF9NG3pPvPlBMHJy',
                android: 'lWKCUGJdG6axXm5pPLUHhDZaDgrpQOIngCKHEjbnrICXkK2XuoEiMullcBegfysC',
            },
        },
    },
    chasabl: {
        code: "chasabl",
        name: "Chasable",
        webDescription: "Chasable",
        domain: "chasabl.com",
        premiumPlan: "Chasable+",
        logo: require('@/assets/logos/chasabl.png'),
        heroBanner: require('@/assets/banners/hero/chasabl.png'),
        tileBanner: require('@/assets/banners/tile/chasabl.png'),
        icon: require('@/assets/icons/chasabl.png'),
        appIcon: require('@/assets/icons/app-icons/chasabl.png'),
        defaultPattern: 'plaid' as PatternName,
        // Platform-specific IAP product IDs
        inAppProductIdsIos: ["CHAS01A", "CHAS12A"],
        inAppProductIdsAndroid: ["chas01a", "chas12a"],
        adUnits: {
            ios: "ca-app-pub-4261273451842236/5453359589",
            android: "ca-app-pub-4261273451842236/9754393219"
        },
        isRelationshipMulti: false,
        hasAdvancedWeightFeatures: false,
        klipy: {
            apiKeys: {
                web: 'Fi0ddKucR2TJ1yi2TuOpEP3aSqbfE7rVgoaWRC3vfmPU3x1U2G0CaaImS1zcFUbE',
                ios: 'T57ks9zxX3IEpiKxahlJxz7gS15oHHNs6JWW07zmZMwLLS7la2kjtzFFselwKY77',
                android: 'QZgehMa0nmiVjPcYUWekmnrdfzxKDUuu6M3NxX5q6TaCuZGWSOUrMOGNfUg1CEgB',
            },
        },
    },
    ferzu: {
        code: "ferzu",
        name: "Ferzu",
        webDescription: "Ferzu",
        domain: "ferzu.com",
        premiumPlan: "Ferzu+",
        logo: require('@/assets/logos/ferzu.png'),
        heroBanner: require('@/assets/banners/hero/ferzu.png'),
        tileBanner: require('@/assets/banners/tile/ferzu.png'),
        icon: require('@/assets/icons/ferzu.png'),
        appIcon: require('@/assets/icons/app-icons/ferzu.png'),
        defaultPattern: 'bones' as PatternName,
        // Platform-specific IAP product IDs
        inAppProductIdsIos: ["FERZ01A", "FERZ12A"],
        inAppProductIdsAndroid: ["ferz01a", "ferz12a"],
        adUnits: {
            ios: "ca-app-pub-4261273451842236/4140277918",
            android: "ca-app-pub-4261273451842236/8441311543"
        },
        isRelationshipMulti: false,
        hasAdvancedWeightFeatures: false,
        klipy: {
            apiKeys: {
                web: 'H2tr2qAsau575Bdz7jcT3Fjnn5RzCkO6rpBj20EEyVx88tnNLjeiLDrINjOxKcSW',
                ios: 'iQmWHFnQkUsc98sad0U0QmNc0nWE7vGfsLUAQVFJnP4VkWNTZpIah73kLWJoFVEu',
                android: 'tvljauKHdh7SeOmXtOuWUJPABBnZ6sDsGpL7q1HjKkuMUre8zAeQ7fg1gSJQdJ7C',
            },
        },
    },
    pupspace: {
        code: "pupspace",
        name: "Pupspace",
        webDescription: "Pupspace",
        domain: "pupspace.net",
        premiumPlan: "Pupspace Pro",
        logo: require('@/assets/logos/pupspace.png'),
        heroBanner: require('@/assets/banners/hero/pupspace.png'),
        tileBanner: require('@/assets/banners/tile/pupspace.png'),
        icon: require('@/assets/icons/pupspace.png'),
        appIcon: require('@/assets/icons/app-icons/pupspace.png'),
        defaultPattern: 'bones' as PatternName,
        // Platform-specific IAP product IDs
        inAppProductIdsIos: ["PUPS01A", "PUPS12A"],
        inAppProductIdsAndroid: ["pups01a", "pups12a"],
        adUnits: {
            ios: "ca-app-pub-4261273451842236/8824454921",
            android: "ca-app-pub-4261273451842236/7209843123"
        },
        isRelationshipMulti: true,
        hasAdvancedWeightFeatures: false,
        klipy: {
            apiKeys: {
                web: 'SD14M9ij3vh3lIKVBlp6FwipW5Jl59N98XpjEyTSExnFFJttalTvk0D3xxNxL4AX',
                ios: 't6l6Y8F8evyTwJbcc6PDomfX9JPzPFRmnQusxHQaJVbZjV4GO49AWB1rNAjPholf',
                android: 'jtQNEOuymzFudnArR52fhuSLe2tdxHYa61eHVKZpIV1TyKgND5sEFjGq6Ffy6huI',
            },
        },
    }
} as const;

export type CommunityCode = keyof typeof communities;
export type CommunityConfig = typeof communities[CommunityCode];

export const isCommunityCode = (code: unknown): code is CommunityCode => {
    return typeof code === 'string' && Object.prototype.hasOwnProperty.call(communities, code);
};

export type CommunityCategoryCode =
    | 'fandomsRoleplay'
    | 'plusSize'
    | 'menInterestedInMen';

export const communityCategories = [
    {
        key: 'fandomsRoleplay' as const,
        communities: ['ferzu', 'pupspace'] as CommunityCode[]
    },
    {
        key: 'plusSize' as const,
        communities: ['feabie', 'grommr', 'chasabl'] as CommunityCode[]
    },
    {
        key: 'menInterestedInMen' as const,
        communities: ['chasabl', 'grommr', 'pupspace'] as CommunityCode[]
    }
] as const;

export type CommunityCategory = typeof communityCategories[number];

export const getCategoriesForCommunity = (code: CommunityCode): CommunityCategoryCode[] => {
    return communityCategories
        .filter(category => category.communities.includes(code))
        .map(category => category.key);
};

export const getCommunityByCode = (code: CommunityCode): CommunityConfig => {
    return communities[code];
};

/**
 * Resolve the community that owns a given in-app product id, checking both the iOS and
 * Android product id lists across every community. Used to route a purchase to the correct
 * community/backend regardless of which community is currently active.
 */
export const getCommunityByProductId = (productId: string): CommunityConfig | undefined => {
    return Object.values(communities).find(c =>
        (c.inAppProductIdsIos as readonly string[]).includes(productId) ||
        (c.inAppProductIdsAndroid as readonly string[]).includes(productId)
    );
};

export const getCommunityByDomain = (domain: string): CommunityConfig | undefined => {
    const normalizedDomain = domain.toLowerCase();
    return Object.values(communities).find(c => c.domain === normalizedDomain);
};

export const getCommunityCodeFromHostname = (hostname: string): CommunityCode | undefined => {
    try {
        const normalizedHostname = hostname.toLowerCase().split(':')[0];

        // First check if the entire hostname matches a community domain.
        const directMatch = getCommunityByDomain(normalizedHostname);
        if (directMatch) {
            return directMatch.code as CommunityCode;
        }

        // Check if hostname is a subdomain (app.ferzu.com should match ferzu.com).
        const parts = normalizedHostname.split('.');
        if (parts.length >= 2) {
            const baseDomain = parts.slice(-2).join('.');
            const communityMatch = getCommunityByDomain(baseDomain);
            if (communityMatch) {
                return communityMatch.code as CommunityCode;
            }
        }
    } catch (error) {
        console.error('Failed to process hostname for community detection:', error);
    }

    return undefined;
};

export const getCommunityCodeFromAppLinkUrl = (url: string): CommunityCode | undefined => {
    try {
        const parsedUrl = new URL(url);
        if (parsedUrl.protocol !== 'https:') return undefined;

        const normalizedHostname = parsedUrl.hostname.toLowerCase();
        const communityMatch = Object.values(communities).find(
            community => normalizedHostname === `app.${community.domain}`
        );

        return communityMatch?.code as CommunityCode | undefined;
    } catch {
        return undefined;
    }
};

export const getAppLinkPathFromUrl = (url: string): string | undefined => {
    try {
        const parsedUrl = new URL(url);
        if (!getCommunityCodeFromAppLinkUrl(url)) return undefined;

        return `${parsedUrl.pathname || '/'}${parsedUrl.search}${parsedUrl.hash}`;
    } catch {
        return undefined;
    }
};

// Helper method to extract community code from domain name
export const getCommunityFromDomain = (): CommunityCode | undefined => {    
    // Skip entirely if not on web platform
    if (Platform.OS !== 'web') return undefined;
    
    // Additional safety check
    if (typeof window === 'undefined' || !window.location) return undefined;

    try {
        const hostname = window.location.hostname.toLowerCase();
        return getCommunityCodeFromHostname(hostname);
    } catch (error) {
        console.error('Failed to process domain for community detection:', error);
    }
    return undefined;
};
